/* istanbul ignore file */
import React from 'react';
import { Button } from 'framework/ui/mui-builder';
import { FloatingButtons } from 'framework/ui/ui-builder';
import logoIcon from 'assets/images/logo-icon.svg';
import { Paper, Typography } from '@mui/material';
import { pageContentSx } from 'framework/ui/layout';

const EF1CreatePageLayout = ({
  children,
  isFormVisible,
  isErrorButtonVisible,
  returnToForm,
}: {
  children: React.ReactNode;
  isFormVisible: boolean;
  isErrorButtonVisible: boolean;
  returnToForm: () => void;
}) => (
  <Paper sx={pageContentSx}>
    <Typography variant="h1" color="brand" display="flex" alignItems="center" mb={4.25}>
      <img src={logoIcon} alt="Syberry logo" width="30" style={{ marginRight: 1 }} />
      EF-1 Employee Profile Information
    </Typography>
    <div>
      {isFormVisible && [<p>Please fill in the form:</p>, children, <FloatingButtons isCancelButtonVisible={false} />]}
      {isErrorButtonVisible && (
        <Button type="button" onClick={returnToForm}>
          Click here to return to the form
        </Button>
      )}
    </div>
  </Paper>
);

export default EF1CreatePageLayout;
